import EmptyImageBadge from './EmptyImageBadge';

export default EmptyImageBadge;
